// extracted by mini-css-extract-plugin
export default {"wrap":"wrap--KoKG1","no-padding":"no-padding--EH_en"};